import React from 'react';
import Swiper from 'react-id-swiper';

interface IOwnProps {
    title?: string;
}

type Props = IOwnProps;

class Carousel extends React.Component<Props, {}>{
    public render() {
        const childrenCount = React.Children.count(this.props.children);

        if (childrenCount === 0) { return null };

        const params = {
            speed: 400,
            autoplay: false,
            slidesPerView: 2,
            centeredSlides: false,
            loop: false,
            spaceBetween: 0,
            simulateTouch: true,
            roundLengths: true,
            containerClass: `slider slider--linear swiper-container ${childrenCount === 1 ? 'slider--no-navigation' : childrenCount === 2 ? 'slider--no-desktop-pagination' : ''}`,
            wrapperClass: `slider__container ${childrenCount === 1 ? 'swiper-wrapper' : ''}`,
            breakpoints: {
                566: {
                    slidesPerView: 1
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            renderNextButton: () =>
                <nav className="slider__navigation">
                    <a href="/#" className="slider__navigation__item slider__navigation__item--prev swiper-button-prev">
                        <span className="text">Næste</span>
                        <span className="icon">
                            <svg className="svg-icon svg-icon--arrow-big">
                                <use xlinkHref="/dist/svg/svg-sprite.svg#arrow-big" />
                            </svg>
                        </span>
                    </a>
                    <a href="/#" className="slider__navigation__item slider__navigation__item--next swiper-button-next">
                        <span className="text">Forrige</span>
                        <span className="icon">
                            <svg className="svg-icon svg-icon--arrow-big">
                                <use xlinkHref="/dist/svg/svg-sprite.svg#arrow-big" />
                            </svg>
                        </span>
                    </a>
                </nav>,
            renderPrevButton: () => '',
            pagination: {
                el: '.slider__pagination',
                clickable: true
            },
            renderPagination: () => <div className="slider__pagination" />
        }

        return (
            <React.Fragment>
                <section className="section">
                    {this.props.title &&
                        <div className="deck deck--brand">
                            <div className="w--md banner-title">
                                <h1>Kontakt os</h1>
                            </div>
                        </div>
                    }
                    <div className="deck deck--brand has-slider">
                        <div className="w--md">
                            <Swiper className="slider slider--linear swiper-container" {...params}>
                                {React.Children.map(this.props.children, (child: any, i: number) => {
                                    return (
                                        <div className={'slider__container__item'.cAppend(childrenCount, 'swiper-slide-active')} key={i}>
                                            {child}
                                        </div>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Carousel;